import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const Container = styled.div``

export const CustomIcon = styled(Icon)`
  position: absolute;
  :before {
    background-color: ${({ theme }) => theme.colors.secondary.normal};
  }
`

export const CustomButton = styled(Button)`
  max-width: 94px;
  margin-left: 4px;
`

export const CustomForm = styled.form`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
